// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-41eb7cc0] .img-div,[data-v-41eb7cc0] .img-div>div,[data-v-41eb7cc0] img,[data-v-41eb7cc0] picture,[data-v-41eb7cc0] picture img{aspect-ratio:1/1;object-fit:cover}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
